import { AutoreplySentEntry } from 'lib-shared-legacy-types';

import { LogEntry } from './logEntry';

type AutoreplySentProps = {
  entry: AutoreplySentEntry;
};

export const AutoreplySent = ({ entry }: AutoreplySentProps): JSX.Element => {
  const text = `Conversation autoreply sent with template ${entry.template_name}`;

  return <LogEntry entry={entry} text={text} />;
};
